module.exports = {
  CloseProject: '项目关闭',
  RebuildProject: '项目重开',
  ProjectNo: '项目编号',
  CustomerName: '客户名称',
  ProjectStatus: '项目状态',
  ProjectName: '项目名称',
  ProjectCycle: '项目周期',
  ProjectManager: '项目经理',
  ProjectDepartment: '项目部门',
  ProjectOffice: '项目公司',
  ExpectIncome: '预计收入',
  ExpectCost: '预计成本',
  ExpectExpense: '预计费用',
  RealIncome: '实际收入',
  RealCost: '实际成本',
  RealExpense: '实际费用',
  SettleCurrency: '核算币种',
  Remarks: '项目说明',
  ExpectTotalCost: '预计总支出',
  RealTotalCost: '实际总支出',
  ExpectProfitTate: '预计利润率',
  RealProfitTate: '实际利润率',
  ReceiveStatus: '收款状态',
  PayStatus: '付款状态',
  StartDate: '开始日期',
  EndtDate: '结束日期'
}
